import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c8baf6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-container" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "优秀作品", -1))
const _hoisted_5 = { class: "title-desc" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_7 = { class: "work-list-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightOutlined = _resolveComponent("ArrowRightOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ExcellentWorkList = _resolveComponent("ExcellentWorkList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "link-more hover-link",
            to: "/excellent"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_ArrowRightOutlined, { class: "icon-link-more" })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ExcellentWorkList, {
          list: _ctx.homeService.userCreationList
        }, null, 8, ["list"])
      ])
    ])
  ]))
}